import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { firebaseConnect } from 'react-redux-firebase'
import { routerActions } from 'react-router-redux'
import moment from 'moment'
import { userIsAuthenticated } from '../behaviors'

import * as assets from '../assets'
import * as UI from '../components'
import { hasEarlyAccess } from '../helpers'

class Closed extends React.Component {
  componentWillReceiveProps(newProps) {
    const { storefront: { endTime }, profile, redirectToAllocation } = newProps

    if (profile.isLoaded) {
      if (hasEarlyAccess(profile)) {
        if (moment(endTime).isBefore(moment())) {
          redirectToAllocation()
        }
      }
    }
  }

  render() {
    const { storefront } = this.props

    return (
      <UI.Card image={assets.logo}>
        <UI.Text center size="massive">
          Thank You!
        </UI.Text>

        <UI.Divider hidden />

        <UI.Text center>The {storefront.name} Token Sale is closed.</UI.Text>

        <UI.Divider hidden />

        <UI.Text center>
          Keep an eye on your email for future announcements.
        </UI.Text>

        <UI.Divider hidden />

        <UI.Text center>
          If you haven't yet, please{' '}
          <UI.Link to="/identity_validation">verify your identity</UI.Link>, you
          will only be able to claim your tokens after you do.
        </UI.Text>

        <UI.Text center />
      </UI.Card>
    )
  }
}

const selectors = createStructuredSelector({
  storefront: (state, { storefront }) => storefront,
  profile: ({ firebase }) => firebase.profile,
})

const actions = (dispatch, props) => ({
  redirectToAllocation: () => dispatch(routerActions.replace('/')),
})

export default compose(
  firebaseConnect(),
  connect(selectors, actions),
  userIsAuthenticated()
)(Closed)



// WEBPACK FOOTER //
// ./src/screens/Closed.js